import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class EnderecoService {
  private baseUrl: string;
  private baseEnderecoUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
    this.baseEnderecoUrl = this.configService.enderecoApi;
  }

  getTipoEndereco() {
    return this.http.get(this.baseUrl + `/v1/enderecos/tipo`);
  }

  getEstados() {
    const states = [
      { id: 1, nome: 'AC' }, // Acre
      { id: 2, nome: 'AL' }, // Alagoas
      { id: 3, nome: 'AP' }, // Amapá
      { id: 4, nome: 'AM' }, // Amazonas
      { id: 5, nome: 'BA' }, // Bahia
      { id: 6, nome: 'CE' }, // Ceará
      { id: 7, nome: 'DF' }, // Distrito Federal
      { id: 8, nome: 'ES' }, // Espírito Santo
      { id: 9, nome: 'GO' }, // Goiás
      { id: 10, nome: 'MA' }, // Maranhão
      { id: 11, nome: 'MT' }, // Mato Grosso
      { id: 12, nome: 'MS' }, // Mato Grosso do Sul
      { id: 13, nome: 'MG' }, // Minas Gerais
      { id: 14, nome: 'PA' }, // Pará
      { id: 15, nome: 'PB' }, // Paraíba
      { id: 16, nome: 'PR' }, // Paraná
      { id: 17, nome: 'PE' }, // Pernambuco
      { id: 18, nome: 'PI' }, // Piauí
      { id: 19, nome: 'RJ' }, // Rio de Janeiro
      { id: 20, nome: 'RN' }, // Rio Grande do Norte
      { id: 21, nome: 'RS' }, // Rio Grande do Sul
      { id: 22, nome: 'RO' }, // Rondônia
      { id: 23, nome: 'RR' }, // Roraima
      { id: 24, nome: 'SC' }, // Santa Catarina
      { id: 25, nome: 'SP' }, // São Paulo
      { id: 26, nome: 'SE' }, // Sergipe
      { id: 27, nome: 'TO' }, // Tocantins
    ];

    return states;
  }

  getCidades(estadoId: string) {
    return this.http.get(
      this.baseUrl + `/v1/enderecos/cidade?&idEstado=${estadoId}`
    );
  }

  getEnderecoByCep(cep: string) {
    return this.http.get(this.baseEnderecoUrl + `/v1/logradouros/${cep}`);
  }
}
